import apis from './apis';

export const getOrderById = orderId => apis.get(`/orders/${orderId}/`);

export const getOrders = ({ searchPage, searchPageSize }) =>
  apis.get('orders/', {
    params: {
      searchPage,
      searchPageSize,
    },
  });
